var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51562 3.17188C8.28645 3.17188 9.0052 3.36979 9.67188 3.76562C10.3385 4.14062 10.8594 4.66145 11.2344 5.32812C11.6302 5.9948 11.8281 6.72395 11.8281 7.51562C11.8281 8.57812 11.4844 9.51562 10.7969 10.3281L10.9844 10.5156H11.5156L14.8281 13.8281L13.8281 14.8281L10.5156 11.5156V10.9844L10.3281 10.7969C9.51562 11.4844 8.57812 11.8281 7.51562 11.8281C6.72395 11.8281 5.9948 11.6406 5.32812 11.2656C4.66145 10.8698 4.13021 10.3385 3.73438 9.67188C3.35938 9.0052 3.17188 8.28645 3.17188 7.51562C3.17188 6.72395 3.35938 5.9948 3.73438 5.32812C4.13021 4.66145 4.66145 4.14062 5.32812 3.76562C5.9948 3.36979 6.72395 3.17188 7.51562 3.17188ZM7.51562 4.51562C6.6823 4.51562 5.97395 4.8073 5.39062 5.39062C4.8073 5.97395 4.51562 6.6823 4.51562 7.51562C4.51562 8.34895 4.8073 9.0573 5.39062 9.64062C5.97395 10.224 6.6823 10.5156 7.51562 10.5156C8.34895 10.5156 9.0573 10.224 9.64062 9.64062C10.224 9.0573 10.5156 8.34895 10.5156 7.51562C10.5156 6.6823 10.224 5.97395 9.64062 5.39062C9.0573 4.8073 8.34895 4.51562 7.51562 4.51562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFind);
export default __webpack_public_path__ + "static/media/icon_find.7c54dc68f79a171a4d3c2a2828ccf511.svg";
export { ForwardRef as ReactComponent };